import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription as RxJsSubscription } from 'rxjs';
import { RoleSearchParams } from '../../role-search-params';
import { Role } from '../../role';
import { Helpers } from '@app/shared';
@Component({
	selector: 'hpf-role-list',
	templateUrl: './role-list.component.html',
	styleUrls: [],
})
export class RoleListComponent implements OnInit, OnDestroy {
	/** The filters */
	searchParams = new RoleSearchParams(this.route.snapshot.queryParams);
	/** The search params subscription */
	private paramsSubscription: RxJsSubscription;
	/** Used to open or close filter drawer */
	filtersDrawer = false;
	/** Constructor */
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private location: Location
	) {}
	/** Init */
	ngOnInit() {
		// Update query string when params change
		this.paramsSubscription = this.searchParams.subscribe(() => {
			this.location.replaceState(
				'/role',
				Helpers.toQueryString(this.searchParams.toObject())
			);
		});
	}
	/** Destroy */
	ngOnDestroy() {
		this.paramsSubscription.unsubscribe();
	}
	/** Called when the user select a row in the table */
	onSelect(item: Role) {
		this.router.navigateByUrl(`/role/${item.getId()}`);
	}
	/** Called when the user click on create */
	onCreate() {
		this.router.navigate(['/role/create']);
	}
}
